<template>
  <v-timeline-item
    color="blue"
    large
    icon="far fa-shoe-prints"
  >
    <div class="title pt-3">Walked to a new room</div>
  </v-timeline-item>
</template>

<script>
export default {
  name: 'Walking',
};
</script>

<style scoped>

</style>
